import { fetchCouponGoodsCategories } from '@musinsa/apis-curator';
import {
  lazyPipe,
  validateServiceRequest,
  validateServiceResponse,
  withServiceErrorCapture,
} from '@musinsa/services-common-service-zod4';
import {
  type GetCouponGoodsCategoriesServiceRequest,
  GetCouponGoodsCategoriesServiceRequestSchema,
  type GetCouponGoodsCategoriesServiceResponse,
  GetCouponGoodsCategoriesServiceResponseSchema,
} from './getCouponGoodsCategories.dto';

export const getCouponGoodsCategoriesService = withServiceErrorCapture(
  lazyPipe(
    validateServiceRequest(GetCouponGoodsCategoriesServiceRequestSchema),
    async (
      request: GetCouponGoodsCategoriesServiceRequest,
    ): Promise<GetCouponGoodsCategoriesServiceResponse> => {
      const response = await fetchCouponGoodsCategories(request);
      return { list: response.data.list };
    },
    validateServiceResponse(GetCouponGoodsCategoriesServiceResponseSchema),
  ),
);
